// extracted by mini-css-extract-plugin
export var section = "thank-you-module--section--NoKIX";
export var button = "thank-you-module--button--Yf3px";
export var backAndForthRight = "thank-you-module--backAndForthRight--NrcoS";
export var wobbleRightAndLeft = "thank-you-module--wobbleRightAndLeft--sc4QD";
export var animateBg = "thank-you-module--animateBg--CKmld";